import type { ReactNode } from 'react';

import FunnelStageCard from 'containers/user/critical-elements-monitoring/components/funnel-stage-card';
import type { StageCardDisplayMode } from 'containers/user/critical-elements-monitoring/components/funnel-stage-card';
import ExtensionCard from 'containers/user/critical-elements-monitoring/components/extension-card';
import ExtensionUpsellCard from 'containers/user/critical-elements-monitoring/components/extension-upsell-card';
import {
  getStageDisplayLabel,
  isFunnelRowCohortUnavailable,
} from 'containers/user/critical-elements-monitoring/monitoring-constants';
import type { FunnelCardRowItem } from 'containers/user/critical-elements-monitoring/helpers/build-funnel-card-row';
import { getStageDataStatus } from 'containers/user/critical-elements-monitoring/helpers/get-stage-data-status';
import type { ProspectAvailability } from 'containers/user/critical-elements-monitoring/helpers/get-prospect-availability';
import type {
  CompareTo,
  ExtensionMetric,
  FunnelStageMetric,
} from 'containers/user/critical-elements-monitoring/critical-elements-monitoring.types';

export interface FunnelCardProps {
  item: FunnelCardRowItem;
  compareTo: CompareTo;
  displayMode: StageCardDisplayMode;
  cohortLabel: string;
  prospectAvailability: ProspectAvailability;
  renderStageHeaderAction?: (stage: FunnelStageMetric) => ReactNode;
  renderExtensionHeaderAction?: (extension: ExtensionMetric) => ReactNode;
}

const FunnelCard = ({
  item,
  compareTo,
  displayMode,
  cohortLabel,
  prospectAvailability,
  renderStageHeaderAction,
  renderExtensionHeaderAction,
}: FunnelCardProps) => {
  if (item.kind === 'stage') {
    return (
      <FunnelStageCard
        stageLabel={getStageDisplayLabel(item.stage.stageKey, displayMode)}
        metric={item.stage}
        compareTo={compareTo}
        displayMode={displayMode}
        cohortLabel={cohortLabel}
        dataStatus={getStageDataStatus(
          item.stage,
          displayMode,
          prospectAvailability
        )}
        cohortDataUnavailable={isFunnelRowCohortUnavailable(
          item.stage.stageKey,
          displayMode,
          item.stage.cohortAvailable
        )}
        headerAction={renderStageHeaderAction?.(item.stage)}
      />
    );
  }

  if (item.kind === 'extension') {
    return (
      <ExtensionCard
        metric={item.extension}
        compareTo={compareTo}
        displayMode={displayMode}
        cohortLabel={cohortLabel}
        headerAction={renderExtensionHeaderAction?.(item.extension)}
      />
    );
  }

  return (
    <ExtensionUpsellCard type={item.extensionType} displayMode={displayMode} />
  );
};

export default FunnelCard;
